// @flow strict

/* eslint-disable import/prefer-default-export */

export const pageContainerSize = 1296;
